import * as deviceDetection from '../utils/deviceDetection';
export default function deviceDetectionReducer(state) {
    if (state === void 0) { state = deviceDetection; }
    return state;
}
